import { useEffect } from "react";
import { useLocation } from "react-router";

import { AnimatedOutlet } from "./AnimatedOutlet";

export function TransitionRoot() {
  const { pathname } = useLocation();

  // Both sections group under one key so within-section navigation is
  // handled by their own inner AnimatedOutlet (the shell stays stable);
  // only crossing a section boundary animates here.
  const transitionKey = pathname.startsWith("/content/") ? "content" : "main";

  // Set body background based on route — content detail uses a dark surface,
  // all other routes clear to the default (CSS-defined warm gradient).
  // Managed here (reacting to pathname) rather than in ContentDetailLayout
  // so the background clears immediately on navigation instead of waiting
  // for the exit animation to complete and the component to unmount.
  useEffect(() => {
    if (pathname.startsWith("/content/")) {
      document.body.style.backgroundColor = getComputedStyle(
        document.documentElement,
      )
        .getPropertyValue("--color-surface-dark")
        .trim();
    } else {
      document.body.style.backgroundColor = "";
    }
  }, [pathname]);

  return (
    <AnimatedOutlet transitionKey={transitionKey} animateInitial={false} />
  );
}
